module.exports = __webpack_public_path__ + "static/media/health-pregnancy.99e4d8f2.svg";